import React from "react";

import "./Skeleton.scss";

export const SkeletonAvatar = ({ size = "lg" }) => {
  return <div className={`skeleton skeleton-avatar-${size} rounded-circle`} />;
};

export const SkeletonParagraph = ({ row = 1, ...props }) => {
  let className = "skeleton-paragraph";
  if (props.className) {
    className += " " + props.className;
  }

  return (
    <ul className={className}>
      {[...Array(row)].map((_, index) => (
        <li className="skeleton rounded" key={index} />
      ))}
    </ul>
  );
};

export const SkeletonButton = ({ width, ...props }) => {
  let className = "skeleton skeleton-button rounded-pill";
  if (props.className) {
    className += " " + props.className;
  }
  return <div className={className} style={{ width }} />;
};
